// extracted by mini-css-extract-plugin
module.exports = {"title":"UxcgId_title__OWw_p"};